<template>
  <div id="app">
    <div class="container">
      <flash />
      <user-info-header v-if="isLoggedIn && !noLayout"/>
      <router-view />
    </div>
    <loading-indicator v-if="isLoading" />
  </div>
</template>
<script>
import UserInfoHeader from '@/components/header/UserInfoHeader.vue'
import Flash from '@/components/global/Flash.vue'
import LoadingIndicator from '@/components/global/LoadingIndicator.vue'

export default {
  computed: {
    noLayout() {
      return this.$route.matched.length==0 || (this.$route.meta && this.$route.meta.noLayout);
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    isLoading () {
      return this.$store.getters.isLoading
    }
  },
  components: {
    UserInfoHeader,
    Flash,
    LoadingIndicator,
  },
  mounted () {
    // if (this.isLoggedIn) {
    //   // let's see if there are any updates to the current user object
    //   this.$store.dispatch('loadCurrentUser')
    // }
  }
}
</script>

<style lang="scss" scoped>
#app {
  color: $body-color;
  font-family: $base-font-family;
}


.container {
  margin: 0 auto;
  padding: 45px 10px 90px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  font-size: 1rem;
  line-height: 1.15;

  @media screen and (max-width: 750px) {
    padding: 20px 20px 45px;
  }

  // Typography styles

  /deep/ {
    h1 {
      font-family: $secondary-font-family;
      font-size: $font-size-h1;
      font-weight: normal;
    }

    h2 {
      font-family: $secondary-font-family;
      font-size: $font-size-h2;
      font-weight: normal;
      text-transform: uppercase;
    }
    h3 {
      font-family: $secondary-font-family;
      font-size: $font-size-h3;
      font-weight: normal;
      text-transform: uppercase;
    }
    h4 {
      font-family: $secondary-font-family;
      font-size: $font-size-h4;
      font-weight: normal;
      text-transform: uppercase;
    }
    h5 {
      font-family: $secondary-font-family;
      font-size: $font-size-h5;
      letter-spacing: 1px;
      font-weight: normal;
      text-transform: uppercase;
    }

    h6 {
      font-family: $base-font-family;
      font-size: $font-size;
      //letter-spacing: 1px;
      font-weight: normal;
    }
  }


  & /deep/.italic {
    font-style: italic;
  }

  & /deep/.strong {
    font-weight: 500;
  }

  & /deep/p, & /deep/ul {
    //font-family: $secondary-font-family;
  }

  & /deep/ a {
    text-decoration: none;
    color: inherit;
    &:hover {
        cursor: pointer;
        text-decoration: none;
    }
  }

  & /deep/ input:focus,
  & /deep/ select:focus,
  & /deep/ textarea:focus,
  & /deep/ button {
    &:focus {
      outline: none;
    }
  }

  & /deep/ button {
    &:not(.outline){
      border: none;
    }
  }

  & /deep/ .title {
      // font-size: 1.5rem;
      color: $body-color;
      margin-bottom: 20px;
  }
  & /deep/ .sq-input {
    border-bottom: 1px solid #495057;
    border-radius: 0;
    margin-bottom: 30px;
  }
  & /deep/.error, & /deep/.danger {
    display: inline-block;
    color: $error;
    //font-family: $secondary-font-family;
    font-size: 0.7rem;
    margin-top: 5px;
  }
  & /deep/.mt-0 {
    margin-top: 0 !important
  }
  & /deep/.mt-1 {
    margin-top: 15px !important
  }
  & /deep/.mt-2 {
    margin-top: 30px !important
  }
  & /deep/.mt-3 {
    margin-top: 45px !important
  }
  & /deep/.mt-4 {
    margin-top: 60px !important
  }
  & /deep/.mt-5 {
    margin-top: 70px !important
  }
  & /deep/.mb-0 {
    margin-bottom: 0 !important
  }
  & /deep/.mb-1 {
    margin-bottom: 15px !important
  }
  & /deep/.mb-2 {
    margin-bottom: 30px !important
  }
  & /deep/.mb-3 {
    margin-bottom: 45px !important
  }
  & /deep/.mb-4 {
    margin-bottom: 60px !important
  }
  & /deep/.mb-5 {
    margin-bottom: 70px !important
  }
  & /deep/.l-50 {
    width: 50%;
  }
  & /deep/.sm-100 {
    @media screen and (max-width: 750px) {
        width: 100%;
    }
  }
  & /deep/.text-right {
    text-align: right;
  }

  & /deep/.text-left {
    text-align: left;
    button {
      text-align: left;
      //padding-left: 1px;
    }
  }

  & /deep/.form-row {
    display: flex;
    margin: 0;
    margin-top: 30px;
    flex-direction: column;
    width: 100%;
    // overflow: hidden;
    .form-wrapper {
      display: flex;
      justify-content: space-between;
      & div {
        flex: 1;
        &:nth-child(2n - 1):not(:last-child) {
          margin-right:20px;
        }
        & label {
          font-family: $secondary-font-family;
          letter-spacing: 1px;
          // font-size: 0.875rem;
          color: $body-color;
          font-weight: normal;
        }
      }

      &.sm-three-one {
        & div {
          &:first-child {
            @media screen and (max-width: 750px) {
              flex: 3;
            }
          }
        }
      }
      &.sm-two-one {
        & div {
          &:first-child {
            @media screen and (max-width: 750px) {
              flex: 2;
            }
            @media screen and (max-width: 320px) {
              flex: 1;
            }
          }
        }
      }
      &.md-up-two-two {
        flex-flow: wrap;
        @media screen and (min-width: 750px) {

          & div {
            flex: 1;
            &:nth-child(3) {
              margin-right: 0 !important;
            }
          }
        }
        @media screen and (max-width: 750px){
          & div:first-of-type {
            margin-right: 0;
          }
        }
        @media screen and (max-width: 320px) {
          label {
            text-transform: none;
          }
        }
      }
    }
    &:not(.mobile-columns) {
      .form-wrapper {
        @media screen and (max-width: 750px) {
          flex-direction: column;
        }
        & div {
          &:nth-child(2n - 1){
            @media screen and (max-width: 750px) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  // Global rules for Responsive parts
  @media screen and (max-width: 749px) {
    & /deep/.mobile-only {
      display: block;
    }
    & /deep/.desktop-up {
      display: none;
    }
    & /deep/.mobile-line-break {
      width: 100%;
      display: block;
    }
  }
  @media screen and (min-width: 750px) {
    & /deep/.mobile-only {
      display: none;
    }
    & /deep/.desktop-up {
      display: block;
    }
    & /deep/.desktop-line-break {
      width: 100%;
      display: block;
    }
  }


  & /deep/label {
    margin-bottom: 0;
  }
  & /deep/label, /deep/.uppercase {
    text-transform: uppercase;
  }
  & /deep/.header-with-border {
    //border-bottom: 1px solid $border-color;
    margin-bottom: 20px;
  }

  & /deep/.md-content {
    a {
      text-decoration: underline;
    }
  }

  & /deep/.vue-tel-input {
    border: none;
    &:focus-within {
      box-shadow: none;
    }
  }

  & /deep/ .vti__dropdown {
    padding-left: 0px;
    padding-right: 10px;
    &:focus-visible {
      outline: none;
    }
    .vti__flag {
      margin-left: 0;
    }
    strong {
      font-weight: normal;
    }
    strong, span {
      color: $body-color;
    }
    .vti__flag-wrapper {
      margin-right: 4px !important;
    }

  }


  & /deep/.vue-tel-input {
    &:focus-visible {
      outline: none;
      .vti__dropdown {
        outline: none;
        &:focus {
          box-shadow: none;
        }
      }
      .vti__input {
        box-shadow: none;
      }
      .vti__dropdown-list {
        border: 0;
      }
  }
  }
  & /deep/.vti__input:focus {
    box-shadow: none !important;
  }

  & /deep/.vti__dropdown:focus {
    box-shadow: none !important;
  }


  & /deep/ .vti__dropdown-list {
    border-color: #1F2429;
    .vti__dropdown-item {
      border: none !important;
      padding: 4px 8px
    }
  }

}
</style>


